export default __webpack_public_path__ + "static/camera-path-9931375905e535591a7d695823013f6c.mp4";